module.exports = __webpack_public_path__ + "static/media/  (112).41ae8bed.jpg";